import React from "react";
import wowImage from "../assets/Wow.png";
import wowImage2 from "../assets/Wow2.png";
function Pricing() {
    return (
        <div className="pricing">
            <h2 className="section-title">Planes</h2>
            <div className="pricing-plans row">
                <div className="col-md-4">
                    <img src={wowImage} alt="wow1" style={{width:"25vh"}}/>
                </div>
                <div className="plan col-md-4" style={{alignItems:"center"}}>
                    <p>¡Desde $1.500.000 COP puede 
                    tener procesos de forma inmersiva!</p>
                </div>
                <div className="col-md-4">
                    <img src={wowImage2} alt="wow2" style={{width:"25vh"}}/>
                </div>
            </div>
        </div>
    );
}

export default Pricing;

